import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useInvalidateThreadListQuery } from '../../api/hooks/useInvalidateThreadListQuery'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useRequestsStore } from '../../store/storeRequests'

export const RequestDeteleDialog = ({ open, handleClose, id = false }) => {
    const invalidateThreadListQuery = useInvalidateThreadListQuery()

    const [searchParams] = useSearchParams()
    const params = useParams()
    const navigate = useNavigate()
    const { removeRequest, isLoadingRemoveRequest } = useRequestsStore((state) => state)

    const handleClickDelete = async () => {
        await removeRequest({ threadId: id })

        const projectId = searchParams.get('workplaceId')

        if (params.requestId) {
            const workplaceId = projectId ? `&workplaceId=${projectId}` : ''
            navigate(
                `/requests?is_archived=${searchParams.get('is_archived') === 'true' ? 'true' : 'false'}${workplaceId}`,
            )
        }

        invalidateThreadListQuery()

        handleClose()
    }

    return (
        <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickDelete}
            handleClose={handleClose}
            title="Удалить запрос?"
            submitButtonText="Удалить"
            isDisabled={isLoadingRemoveRequest}>
            Запрос будет удален без возможности восстановления
        </ConfirmDialogWrapper>
    )
}
